(function(angular) {
  var FavouritesController = function(
      $scope, $location, $timeout, $localStorage, $sessionStorage, $http,
      $window, likes) {
    var self = this;

    self.data = [];
    self.params = {
      loader: false,
    };
    self.receiver = '';

    self.request = {
      receivers: [],
    };

    self.sended = null;

    self.init = function(dataUrl, sendUrl) {
      self.params['dataUrl'] = dataUrl;
      self.params['sendUrl'] = sendUrl;
      likes.load();
      self.loadData();
    };

    self.loadData = function() {
      self.params.loader = true;
      var dto = {
        demand: {
          uid: likes.get(),
          limit: null,
          offset: null,
        },
      };
      $http.post(self.params['dataUrl'], dto, {}).
          then(function(response) {
            self.data = response.data.data.slice();

            $timeout(function() {
              self.params.loader = false;

              likes.update(self.data);
            });
          }, function(response) {
            self.data = [];
            self.params.loader = false;
          });
    };

    self.openPageAnimation = function(event) {
      event.preventDefault();
      var target = event.target,
          href = target.href;

      angular.element('body').addClass('menu-open');
      angular.element('body > .loading').removeClass('loading--hide');

      $timeout(function() {
        //As an HTTP redirect (back button will not work )
        window.location.replace(href);
        //like if you click on a link (it will be saved in the session history,
        //so the back button will work as expected)
        window.location.href = href;
      }, (400));
    };

    self.dislike = function(model) {
      angular.forEach(self.data, function(val, key) {
        if (val.uid === model.uid) {
          self.data.splice(key, 1);
          return;
        }
      });

      likes.update(self.data);
    };

    self.addReceiver = function(field) {
      var value = field.$viewValue;
      if (field.$valid && field.$touched && field.$dirty && value &&
          !~self.request.receivers.indexOf(value)) {
        self.request.receivers.push(value);
        // field.$setPristine();
        self.receiver = '';
      }
    };

    self.submitForm = function(form) {
      if (form.$valid && !form.$pristine && (self.request.receivers.length > 0 || self.receiver)) {

        self.request.models = likes.get();

        var request = angular.copy(self.request);

        if (self.receiver) {
          request.receivers.push(self.receiver);
        }

        self.params.loader = true;

        $http.post(self.params['sendUrl'], request).then(function(response) {

          self.params.loader = false;

          form.$setSubmitted();
          self.sended = true;
          self.request = {receivers: []};
          self.receiver = '';
          form.$setPristine();
          angular.element('.form-control--has-value').removeClass('form-control--has-value')
          $timeout(function(){
            self.sended = null;
          }, 3000);
        }, function(response) {

          self.params.loader = false;

          form.$setSubmitted();
          self.sended = false;
          $timeout(function(){
            self.sended = null;
          }, 3000);
        });
      }
    };

  };

  angular.module('ins.models').
      controller('FavouritesController', FavouritesController);
})(window.angular);